module.exports = __webpack_public_path__ + "img/logoArty2.44bc2181.svg";